var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14H0.25C0.25 14.4142 0.585786 14.75 1 14.75L1 14ZM11 14V14.75C11.4142 14.75 11.75 14.4142 11.75 14H11ZM11 6.77778H11.75C11.75 6.36356 11.4142 6.02778 11 6.02778V6.77778ZM1 6.77778V6.02778C0.585786 6.02778 0.25 6.36356 0.25 6.77778H1ZM3.89286 6.77778V3.88889H2.39286V6.77778H3.89286ZM3.89286 3.88889C3.89286 3.52576 4.00671 2.96567 4.32522 2.51837C4.61621 2.10974 5.10509 1.75 6 1.75V0.25C4.60919 0.25 3.66951 0.853227 3.10335 1.64829C2.56472 2.4047 2.39286 3.28905 2.39286 3.88889H3.89286ZM6 1.75C6.89491 1.75 7.38379 2.10974 7.67478 2.51837C7.99329 2.96567 8.10714 3.52576 8.10714 3.88889H9.60714C9.60714 3.28905 9.43528 2.4047 8.89665 1.64829C8.33049 0.853227 7.39081 0.25 6 0.25V1.75ZM8.10714 3.88889V6.77778H9.60714V3.88889H8.10714ZM1 14.75H11V13.25H1V14.75ZM11.75 14V6.77778H10.25V14H11.75ZM0.25 6.77778V14H1.75V6.77778H0.25ZM3.14286 6.02778H1V7.52778H3.14286V6.02778ZM11 6.02778H8.85714V7.52778H11V6.02778ZM8.85714 6.02778H3.14286V7.52778H8.85714V6.02778Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.svg";
export { ForwardRef as ReactComponent };